import About from '../views/emojiapp/About.vue';

let routes = [
    {
        path: '/emojiapp/about',
        name: 'emojiapp/about',
        component: About,
        meta: {}
    }
];

export default routes;